import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { humanize } from 'underscore.string';
import { Table, TableHeader, TableHead, TableRow, TableBody, TableFooter, TableCell, } from 'components/ui/table';
import Link from 'components/v2/Link';
import ExternalLinkIcon from 'components/v2/icons/ExternalLinkIcon';
import { isIntermodalShipmentType } from 'helpers/shipment-types';
import { withTranslation } from 'react-i18next';
import { sluggify } from 'utils/localization/utils';
import formatMoney from 'utils/formatters/Money';
import { AuthorizationWrapper } from 'components/wrappers/AuthorizationWrapper';
import { REGIONS } from 'constants/Regions';
class CostSummary extends Component {
    getTotal() {
        const { isShipper, job: { payables, receivables }, } = this.props;
        const ledger = isShipper ? receivables : payables;
        return ledger.reduce((acc, item) => acc + (item.value || 0), 0);
    }
    renderTotal() {
        const { t, isShipper, job: { currency }, } = this.props;
        return (React.createElement(TableRow, null,
            React.createElement(TableCell, null, "\u00A0"),
            !isShipper && React.createElement(TableCell, null, "\u00A0"),
            React.createElement(TableCell, { className: "font-bold" }, t('TOTAL')),
            React.createElement(TableCell, { className: "text-right font-bold" }, formatMoney(this.getTotal(), currency))));
    }
    renderLineItems(accountingDoc, unprocessed = false) {
        const { t, isShipper, job: { external_payables, external_receivables, shipment_type, currency, receivables, payables, }, } = this.props;
        let lineItems = [];
        const isDrayage = isIntermodalShipmentType(shipment_type);
        if (!unprocessed) {
            lineItems = isShipper
                ? receivables.filter((lineItem) => lineItem.invoice_id === accountingDoc._id)
                : payables.filter((lineItem) => lineItem.payout_id === accountingDoc._id);
        }
        if (unprocessed) {
            lineItems = isShipper
                ? receivables.filter((lineItem) => !lineItem.invoice_id || !lineItem.processed)
                : payables.filter((lineItem) => !lineItem.payout_id || !lineItem.processed);
        }
        const costType = isShipper ? 'invoices' : 'carrier-payouts';
        return (React.createElement(React.Fragment, null, lineItems.map((lineItem) => (React.createElement(TableRow, null,
            React.createElement(TableCell, null, accountingDoc && (React.createElement(Link, { url: `/${costType}/${accountingDoc._id}` },
                React.createElement("div", { className: "flex align-middle items-center space-x-1" },
                    React.createElement("p", null, accountingDoc.number),
                    React.createElement(ExternalLinkIcon, { className: "w-4 h-4" }))))),
            !isShipper && (React.createElement(TableCell, null, accountingDoc && t(sluggify(accountingDoc.status)))),
            React.createElement(TableCell, null, t(sluggify(lineItem.message))),
            React.createElement(TableCell, { className: "text-right" }, formatMoney(lineItem.value, currency)))))));
    }
    render() {
        const { isShipper, t, accountingDocs } = this.props;
        const label = isShipper
            ? t('INVOICE', { count: 1 })
            : t('PAYOUT', { count: 1 });
        return (React.createElement("div", { className: "job_details__payout" },
            React.createElement("h4", { className: "mb-2 text-grey-darker" }, `${label} ${t('SUMMARY')}`),
            React.createElement(AuthorizationWrapper, { excludedRegions: [REGIONS.AP] },
                React.createElement("div", { className: "table-wrapper my-4" },
                    React.createElement(Table, { className: "" },
                        React.createElement(TableHeader, null,
                            React.createElement(TableRow, { className: "bg-gray-50" },
                                React.createElement(TableHead, { sortKey: "number" }, `${label} ${t('NUMBER')}`),
                                !isShipper && (React.createElement(TableHead, { sortKey: "status" }, t('STATUS'))),
                                React.createElement(TableHead, { sortKey: "charge" }, t('CHARGE')),
                                React.createElement(TableHead, { sortKey: "amount", className: "text-right" }, t('AMOUNT')))),
                        React.createElement(TableBody, null,
                            accountingDocs.map((accountingDoc) => this.renderLineItems(accountingDoc, false)),
                            this.renderLineItems(null, true),
                            this.renderTotal(null, true)))))));
    }
}
CostSummary.propTypes = {
    isShipper: PropTypes.bool,
    job: PropTypes.shape({
        external_payables: PropTypes.arrayOf(PropTypes.shape({
            message: PropTypes.string,
            type: PropTypes.string.isRequired,
            value: PropTypes.number.isRequired,
        })),
        external_receivables: PropTypes.arrayOf(PropTypes.shape({
            message: PropTypes.string,
            type: PropTypes.string.isRequired,
            value: PropTypes.number.isRequired,
        })),
    }),
    accountingDocs: PropTypes.arrayOf(PropTypes.shape({
        number: PropTypes.string,
        status: PropTypes.string,
    })).isRequired,
};
CostSummary.defaultProps = {
    job: {
        payables: [],
    },
    isShipper: false,
};
export default withTranslation()(CostSummary);
